import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  cartId: null,
  data: {},
  itemId: null,
  isValidCustomForm: true,
  isValidCustomPPU: true,
  purchaseDetails: {}, /* {
    purchaseId: 124, purchaseNumber: '124566666'
  } */
  items: []
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.items = action.payload;
    },
    addItem(state, action) {
      const existing = state.items.find((i) => i.id === action.payload.id);
      if (existing) {
        existing.qty += action.payload.qty ?? 1;
      } else {
        state.items.push({ id: action.payload.id, qty: action.payload.qty ?? 1 });
      }
    },
    setCartData(state, action) {
      state.data = action.payload.cart;
      state.cartId = action.payload.cart.id;
      state.itemId = action.payload.cart.items[0]?.id || null;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearCart(state) {
      state.items = [];
      state.pricingTotal = null;
      state.isLoading = false;
      state.error = null;
    },
    setPurchaseDetails(state, action) {
      state.purchaseDetails = action.payload;
    },
    setValidCustomForm(state, action) {
      state.isValidCustomForm = action.payload;
    },
    setValidCustomPPU(state, action) {
      state.isValidCustomPPU = action.payload;
    }
  }
});

export const { addItem, setCartData, setLoading: setCartLoading, setError, clearCart, setPurchaseDetails, setCartItems, setValidCustomForm, setValidCustomPPU } = cartSlice.actions;
// Selectors
export const selectCartItems = (state) => state.cart.items;
export const selectCartItemCount = (state) => state.cart.items.length;
export const selectIsValidCustomForm = (state) => state.cart.isValidCustomForm;
export const selectIsValidCustomPPU = (state) => state.cart.isValidCustomPPU;

export default cartSlice.reducer;
